import { create } from "zustand";
import lsKeys from "../components/default_values/defaultKeys";

export const useCapacityStore = create((set) => ({
  showTimeOffs: true,
  setShowTimeOffs: (newValue) => set({ showTimeOffs: newValue }),
  userCapacity: [],
  setUserCapacity: (newValue) => set({ userCapacity: newValue }),
  projectCapacity: [],
  setProjectCapacity: (newValue) => set({ projectCapacity: newValue }),
  hideOtherUsers: localStorage.getItem(lsKeys.CAPACITY_HIDE_OTHERS) === "true",
  setHideOtherUsers: (newValue) => {
    localStorage.setItem(lsKeys.CAPACITY_HIDE_OTHERS, newValue.toString());
    set({ hideOtherUsers: newValue });
  },
}));
